export { contextModuleName as moduleName } from '@shared';
export const maxProfiles = 8;
export const maxProfilesMobile = 6;
export const maxCouncilUnitsSuggestions = 3;
